import React from 'react';

const RequesterFooter = () => (
  <footer style={{ background: '#0b79b8', padding: '5px 5px', color: '#fff' }}>
    <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'space-between', width: '100%', padding: '0 1rem' }}>
      <div>
        <a
          href="#"
          style={{ textDecoration: 'underline', marginLeft: '5px', color: '#fff', fontSize: '14px' }}
          onMouseOver={(e) => { e.currentTarget.style.textDecoration = 'none'; e.currentTarget.style.color = '#ff6600'; }}
          onMouseOut={(e) => { e.currentTarget.style.textDecoration = 'underline'; e.currentTarget.style.color = '#fff'; }}
        >
          TERM OF USE
        </a>
      </div>
      <div>
        <p style={{ margin: 0, textAlign: 'right', fontSize: '14px' }}>&copy; 2025 IT People Network LLC . All Rights Reserved</p>
      </div>
    </div>
  </footer>
);

export default RequesterFooter;
